module.exports = __webpack_public_path__ + "img/Snippets.e3b6d05a.svg";